import services from "@/http";
import * as types from "./mutation-types";

function generateLinkDownload(file, type) {
  const blobFile = new Blob([file], { type });
  const link = window.URL.createObjectURL(blobFile);
  return link;
}

function createAnchorLink(link, name) {
  const anchor = document.createElement("a");
  anchor.href = link;
  anchor.download = name;
  return anchor;
}

export const ActionSaveRelatorioOportunidades = async ({ commit }, payload) => {
  try {
    const file = await services.relatorios.oportunidades(payload);
    const type = file.headers.map["content-type"][0];
    const link = generateLinkDownload(file.body, type);
    const anchor = createAnchorLink(link, "oportunidades.xlsx");
    anchor.click();
    anchor.remove();
  } catch (error) {
    console.error(error);
  }
};

export const ActionSetRelatorio = ({ commit }, payload) => {
  commit(types.SET_RELATORIO_OPORTUNIDADES, payload);
};

export const ActionNewRelatorio = ({ commit }) => {
  const relatorio = {
    cabecalho: [],
    filtros: {},
  };
  commit(types.SET_RELATORIO_OPORTUNIDADES, relatorio);
};
